import React from 'react';

const BusinessFeatures = () => {
  const features = [
    {
      id: 1,
      title: "Hassle free relocation",
      description: "Simplify your move and leave the heavy lifting to us!",
      icon: "🚚",
      gradient: "from-blue-500 to-purple-600"
    },
    {
      id: 2,
      title: "No Maintenance Worries",
      description: "From regular wear-and-tear to accidental damage, we take care of it all.",
      icon: "🛠️",
      gradient: "from-green-500 to-teal-600"
    },
    {
      id: 3,
      title: "Customise your lifestyle",
      description: "Experience the flexibility of customizing your living space with us when you rent.",
      icon: "🎨",
      gradient: "from-orange-500 to-red-600"
    },
    {
      id: 4,
      title: "Upgrade",
      description: "Always stay ahead of the curve with our ever-evolving selection.",
      icon: "📈",
      gradient: "from-purple-500 to-pink-600"
    }
  ];

  return (
    <section className="w-full bg-gradient-to-br from-gray-900 to-gray-800 py-8 lg:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8 lg:mb-12">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-2">
            Why Choose fillmyfloor?
          </h2>
          <p className="text-base lg:text-lg text-gray-300 max-w-2xl mx-auto">
            Experience the future of furniture rental with our innovative approach
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {features.map((feature, index) => (
            <div
              key={feature.id}
              className="relative group"
            >
              {/* Feature Card */}
              <div className="relative bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-4 lg:p-6 border border-white border-opacity-20 overflow-hidden transition-all duration-300 hover:bg-opacity-20 hover:transform hover:-translate-y-1">
                
                {/* Background Pattern */}
                <div className="absolute inset-0 opacity-10">
                  <div className="absolute top-2 right-2 w-8 h-8 bg-white rounded-full"></div>
                  <div className="absolute bottom-3 left-3 w-4 h-4 bg-white rounded-full"></div>
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-0.5 bg-white rotate-45"></div>
                </div>

                {/* Content */}
                <div className="relative z-10">
                  {/* Icon */}
                  <div className={`w-12 h-12 lg:w-14 lg:h-14 bg-gradient-to-r ${feature.gradient} rounded-xl flex items-center justify-center mb-4 shadow-lg group-hover:shadow-xl transition-all duration-300 transform group-hover:scale-110`}>
                    <span className="text-white text-lg lg:text-xl">{feature.icon}</span>
                  </div>

                  {/* Text Content */}
                  <div>
                    <h3 className="text-lg lg:text-xl font-bold text-white mb-2 group-hover:text-gray-100 transition-colors duration-200">
                      {feature.title}
                    </h3>
                    <p className="text-gray-300 text-sm leading-relaxed group-hover:text-gray-200 transition-colors duration-200">
                      {feature.description}
                    </p>
                  </div>

                  {/* Hover Effect Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-r from-white to-transparent opacity-0 group-hover:opacity-5 transition-opacity duration-300 rounded-xl"></div>
                </div>

                {/* Corner Accent */}
                <div className={`absolute top-0 right-0 w-8 h-8 bg-gradient-to-br ${feature.gradient} opacity-20 group-hover:opacity-30 transition-opacity duration-300 rounded-bl-xl`}></div>
              </div>

              {/* Connection Line (for desktop) */}
              {index < features.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 w-6 h-0.5 bg-gradient-to-r from-gray-600 to-transparent"></div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-8 lg:mt-12">
          <div className="inline-flex items-center space-x-3">
            <div className="w-12 h-0.5 bg-gradient-to-r from-transparent to-gray-600"></div>
            <button className="bg-white text-gray-900 px-6 py-3 rounded-lg text-base font-semibold hover:bg-gray-100 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl">
              Start Your Journey
            </button>
            <div className="w-12 h-0.5 bg-gradient-to-l from-transparent to-gray-600"></div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-10 left-8 w-24 h-24 bg-white bg-opacity-5 rounded-full blur-2xl"></div>
        <div className="absolute bottom-10 right-8 w-32 h-32 bg-white bg-opacity-5 rounded-full blur-2xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-48 h-48 bg-white bg-opacity-3 rounded-full blur-2xl"></div>
      </div>
    </section>
  );
};

export default BusinessFeatures; 